export default "__VITE_ASSET__ace5ec51__"